import { render, staticRenderFns } from "./companyFriend.vue?vue&type=template&id=6026eb44&scoped=true"
import script from "./companyFriend.vue?vue&type=script&lang=js"
export * from "./companyFriend.vue?vue&type=script&lang=js"
import style0 from "./companyFriend.vue?vue&type=style&index=0&id=6026eb44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026eb44",
  null
  
)

export default component.exports